import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          null,
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        setUser(res.data);
        // Clean the hash and redirect into admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (err) {
        const detail = err?.response?.data?.detail;
        const status = err?.response?.status;
        if (status === 403) {
          toast.error(detail || "This Google account isn't authorized.");
        } else {
          toast.error(detail || "Sign-in failed. Try again.");
        }
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="grid min-h-screen place-items-center bg-[#F9F8F6] text-[#16302B]">
      <div className="text-center">
        <p className="eyebrow">Signing you in</p>
        <p className="mt-3 font-display text-2xl font-black tracking-tight">Just a sec…</p>
      </div>
    </div>
  );
}
